export enum StatusEnum {
  warning = 'warning',
  success = 'success',
  info = 'info',
  error = 'error'
}
